export default {
  title: {
    id: 'merchant_options_payment_payout_information_for_hyperwallet',
    defaultMessage: 'Payout information for Hyperwallet',
  },
  providePaymentInfos: {
    id: 'merchant_options_payment_payout_information_cta',
    defaultMessage: 'Provide your payment information',
  },
}
